
/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains AuditLogs using MUI components
  ------------------------------------------------------------------------------------------------------- */

import React, { useEffect, useState } from 'react';
import AuditLogSearchFilter from '../AuditLogSearchFilter/AuditLogSearchFilter';
import CustomBottomPagination from '../../../Components/custom_components/CustomBottomPagination/CustomBottomPagination';
import CustomTable from '../../../Components/custom_components/CustomTable/CustomTable';
import Loader from '../../../Components/Loader/Loader';
import { handlePaginationEntries } from '../../../utils/pagination';
import { get_auditlog_with_pagination } from '../../../config/AuditLogs/AuditLogsApis';

function AuditLogs() {

    const [changeHistoryList, setchangeHistoryList] = useState([]);

    // Calculate the total pages based on the number of items and items per page
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItemPerPage, setTotalItemPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({ start: 0, end: 0, totalEntries: 0 });

    const [filterValues, setFilterValues] = useState({}); // Define filter values state
    const [isLoading, setIsLoading] = useState(false); // Loader state


    // Columns for the table
    // const columns = [
    //     { title: "#", key: "key" },
    //     { title: "Log Time", key: "changed_at" },
    //     { title: "Updated By", key: "changed_by_name" },
    //     { title: "Affected Area", key: "type" },
    //     { title: "Description", key: "description" },

    // ].filter(column => column.key !== "actions"); //removes the "Actions" column when hasActionPermissions is false
    // const rows = () =>
    //     changeHistoryList?.map((item, index) => ({
    //         key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
    //         changed_at: item?.changed_at || "-",
    //         changed_by_name: item?.changed_by_name || "-",
    //         entity_name: item?.entity_name || "-",
    //         description: item?.description || "-",
    //         type: item?.type
    //             ? item.type.charAt(0).toUpperCase() + item.type.slice(1)
    //             : "-",
    //     }));
    // Columns for the table
    const columns = [
        { title: "#", key: "key" },
        { title: "Log Time", key: "changed_at" },
        { title: "Changed By", key: "changed_user" },
        { title: "Affected Module", key: "affected_module" },
        { title: "Affected Area", key: "affected_area" },
        { title: "Description", key: "change_description" },
        { title: "Event", key: "event_done" },
        { title: "Status", key: "event_status" },
        { title: "IP Address", key: "ip_address" },
        { title: "Source", key: "source" },
    ]

    // Map the schedule data into table rows
    const rows = () =>
        changeHistoryList?.map((item, index) => ({
            key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
            changed_at: item?.changed_at || "-",
            changed_user: item?.changed_user || "-",
            affected_module: item?.affected_module || "-",
            affected_area: item?.affected_area || "-",
            change_description: item?.change_description || "-",
            event_done: item?.event_done || "-",
            event_status: item?.event_status || "-",
            ip_address: item?.ip_address || "-",
            source: item?.source || "-",
        }));

    // Fetch schedule data on page change or refresh
    useEffect(() => {
        getAuditlogs();
    }, [pageNumber, totalItemPerPage, filterValues]);


    // Fetch schedule data from API
    const getAuditlogs = async () => {
        const formData = new FormData();
        formData.append('page', pageNumber);
        formData.append('pageItemcount', totalItemPerPage);

        // Append filter values to formData
        Object.keys(filterValues).forEach(key => formData.append(key, filterValues[key]));

        try {
            setIsLoading(true)
            const response = await get_auditlog_with_pagination(formData);
            if (response?.status === "success") {

                const data = response?.data;
                setchangeHistoryList(data?.data);
                setTotalPages(data.last_page);
                setPagination(handlePaginationEntries(data.from, data.to, data.total));
            } else {
                setchangeHistoryList([]);
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    };

    // Handle search filter change
    const handleSearchFilter = (filterValues) => {
        setFilterValues(filterValues);
    };

    // Handle pagination changes
    const handlePageChange = (pageNumber) => setPageNumber(pageNumber);
    const handleItemPageCountChange = (pageItemCount) => setTotalItemPerPage(pageItemCount);


    return (
        <div className='report-table-container'>
            <AuditLogSearchFilter
                tableTitle="AuditLogs"
                searchFilter={handleSearchFilter}

                on_change_value={handlePageChange}
                on_page_count_update={handleItemPageCountChange}
            />
            <div className="table-container">
                <CustomTable
                    columns={columns}
                    rows={isLoading ? [] : rows()}
                    isLoading={isLoading}
                />
            </div>
            <div className='pagination-container'>
                {isLoading ? <Loader /> : <CustomBottomPagination
                    items_per_page={totalItemPerPage}
                    current_page={pageNumber}
                    total_page_count={totalPages}
                    on_change_value={handlePageChange}
                    on_page_count_update={handleItemPageCountChange}
                    pagination={pagination}
                />}
            </div>
        </div>
    );
}

export default AuditLogs;
